
const UserService = {
	CURRENT_USER: "current-user",
	
	login: async function(object) {
		return new Promise((resolve, reject) =>{ 
			if (!object || object.email === undefined || object.password === undefined) {
				reject({ status:false, error:"invalid object"});
				return;
			}
			
			const email = object.email.trim();
			const password  = object.password.trim();
			
			if (!email) {
				reject( { status:false, error:"invalid email"} );
				return;
			} 
			
			if (!password) {
				reject( { status:false, error:"invalid password"} );
				return;
			} 
			
			let users = localStorage.getItem("users");
			users = users ? JSON.parse(users) : [];
			let found = false;
			users.forEach( (u) => found = found || (u.email === email && u.password === password));
			if (!found) {
				 reject( { status:false, error:"invalid credentials" } );
				 return;
			} 
			localStorage.setItem(UserService.CURRENT_USER, email);
			resolve( { status:true } );
		});
	},
	
	signup: async function(object) {
		return new Promise((resolve, reject) =>{ 
			if (!object || object.email === undefined || object.password === undefined) {
				reject({ status:false, error:"invalid object"});
				return;
			}
			
			const email = object.email.trim();
			const password = object.password.trim();

			if (!email) {
				reject( { status:false, error:"invalid email"} );
				return;
			} 
			
			if (!password) {
				reject( { status:false, error:"invalid password"} );
				return;
			} 
			
			let users = localStorage.getItem("users");
			users = users ? JSON.parse(users) : [];
			users.push({email, password});
			users = JSON.stringify(users);
			localStorage.setItem("users", users);
			resolve( { status:true } );
		});
	},
	
	logout: function() {
		localStorage.removeItem(UserService.CURRENT_USER);
		return { status: true }
	},
	getCurrentUser: function() {
		return localStorage.getItem(UserService.CURRENT_USER);
	},
	isAuthenticated: function() {
		return UserService.getCurrentUser() ? true : false;
	}
}

export default UserService;